import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Role } from '../../types/shared/Role';
import { AuthService } from './services/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this.authService.isLoggedIn()) {
            this.router.navigate([ '/login' ]);
            return false;
        }

        const role = this.authService.getRole();
        const url = state.url;

        // Redirect retailer to /retailer if they try to access other routes
        if (role === Role.SAMPLE_STUDIO_RETAILER && !url.startsWith('/retailer')) {
            this.router.navigate([ '/retailer' ]).then();
            return false;
        }

        // Producers must not see vehicle data, so the vehicle model pages are not accessible for them
        if (role === Role.SAMPLE_STUDIO_PRODUCER && url.startsWith('/vehicle-models')) {
            this.router.navigate([ '' ]).then();
            return false;
        }

        return true;
    }
}
